<template>
	<div>
		<el-scrollbar ref="scrollBar" height="100vh">
      <page-header></page-header>
      <router-view></router-view>
      <page-footer></page-footer>
    </el-scrollbar>
	</div>
</template>

<script setup>
  import { watch,ref,onMounted } from "vue";
  import pageHeader from './components/pageHeader/index.vue'
	import pageFooter from './components/pageFooter/index.vue'
  import { useRouter } from 'vue-router'
  const route = useRouter()

  const scrollBar = ref(null)
  const screenWidth = ref(null)

  watch(() => route.currentRoute.value,
      () => {
        scrollBar.value.setScrollTop(0)
      }
  )

  onMounted(()=>{
    screenWidth.value = document.body.clientWidth
    if(screenWidth.value <= 750){
      window.location.href = '/index/mobile/index.html'
    }
    window.onresize = () => {
        return (() => {
            screenWidth.value = document.body.clientWidth
            if(screenWidth.value <= 750){
              window.location.href = '/index/mobile/index.html'
            }
        })()
    }
  })


</script>

<style lang="scss" scoped>
.scrollbar-demo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
  color: var(--el-color-primary);
}
</style>
